/**
 * Route for `real-time-link-coupon-interaction-monitoring-influ`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RealTimeLinkCouponInteractionMonitoringInfluPage } from "../features/real-time-link-coupon-interaction-monitoring-influ/RealTimeLinkCouponInteractionMonitoringInfluPage";

export const realTimeLinkCouponInteractionMonitoringInfluRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/real-time-link-coupon-interaction-monitoring-influ",
	component: RealTimeLinkCouponInteractionMonitoringInfluPage,
});

export default realTimeLinkCouponInteractionMonitoringInfluRoute;
